/**
 * Alternative to `Array.flat(1)`
 * @param arr An array like [1,2,3,[1,2]]
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
 */
const flatten = arr => [].concat(...arr);

export { flatten };
//# sourceMappingURL=flatten.js.map
